<template>
  <v-select
    v-model="item"
    :items="items"    
    :loading="isLoading"
    :error-messages="error"    
    label="Tipo de Pedido"    
    item-text="name"
    item-value="key"
    clearable
    outlined
    dense    
    @input="$emit('input', item)"
  />
</template>

<script>
  import orderTypeService from '@/services/tipo-pedido.service';

  export default {
    name: 'SearchOrderTypeSelect',

    props: {
      value: {
        type: [String, Number],
        default: null
      }
    },

    data: () => ({
      isLoading: false,
      error: null,
      items: [],
      item: null,      
    }),

    mounted() {
      this.item = this.value;

      this.fetch();
    },

    methods: {
      fetch() {
        this.isLoading = true;
        orderTypeService.list({}).subscribe(({items}) => {
          this.items = items;
          this.isLoading = false;
        }, () => {
          this.error = 'Erro ao carregar os tipos de pedido';
          this.isLoading = false;
        });
      },      
    }
  };
</script>
